import { NgModule } from '@angular/core';

import { EldGuard } from './eld';
import { RoleGuard } from './role';
import { ParamsGuard } from './params';
import { CompanyFeatureEnabledGuard } from './company-feature-enabled';
import { ApiAccessGuard } from './api-access';
import { NoDemoModeGuard } from './no-demo-mode-guard';
import { NoSupportModeGuard } from './no-support-mode-guard';
import { SupportModeGuard } from './support-mode-guard';
import { GroupAccessGuard } from './group-access';
import { FeatureAccessGuard } from './feature-access';
import { BetaFeatureAccessGuard } from './beta-access';
import { LogSuggestionUnsavedGuard } from './log-suggestion-unsaved';
import { ConfirmPromptGuard } from './confirm-prompt-guard';
import { CompanyOperatingModeGuard } from './operating-mode';
import { SubscriptionPlanGuard } from './subscription-plan';
import { VehicleOrAssetGatewayPresentGuard } from './vehicle-or-asset-gateway-present.guard';
import { LoadboardRedirectGuard } from './loadboard-redirect-guard';
import { DevelopmentEnvironmentGuard } from './development-environment-guard';
import { ComplianceHubRedirectGuard } from './compliance-hub-redirect.guard';
import { WebViewAccessGuard } from './web-view-guard';
import { TeamDrivingRedirectGuard } from './team-driving-redirect.guard';
import { ComplianceOverviewToCSARedirectGuard } from './compliance-overview-csa-redirect-guard';
import { LogEditGuard } from './log-edit-guard';
import { FleetCardsGuard } from './fleet-cards-guard';
import { CanadianCycleGuard } from './canada-cycles-guard';
import { FleetCardsCardApplicationGuard } from './fleet-cards-card-application-guard';
import { LogRemarkGuard } from './log-remark-guard';
import { DispatchDriverWorkflowGuard } from './dispatch-driver-workflow.guard';
import { LogEditItemGuard } from './log-edit-item.guard';
import { RedirectGuard } from './redirect-guard';
import { FleetCardsRolesPermissionsGuard } from './fleet-cards-roles-permissions-guard';
import { FleetCardsFeatureGuard } from './fleet-cards-feature-guard';
import { FacilityMonitoringAccessGuard } from './facility-monitoring-guard';
import { MarketplaceExpansiontAccessGuard } from './marketplace-expansion-access.guard';
import { PerformanceMarkerGuard } from './performance-marker-guard';
import { FPAMRedirectGuard } from './fpam-redirect-guard';
import { BillingManagementAccessGuard } from './billing-management-guard';
import { StatsigFeatureGuard } from './statsig-feature-guard';
import { TripsParamsGuard } from './trips-params-guard';
import { ModeAccessGuard } from './mode-access-guard';
import { LoadboardSettingsGuard } from './loadboard-settings-guard';
import { FleetCardsOrderEligibilityGuard } from './fleet-cards-order-eligibility-guard';
import { ShopGuard } from './shop-guard';
import { SafetyOverviewRedirectGuard } from './safety-overview-redirect-guard';
import { DriverQualificationEnabledGuard } from './driver-qualification-enabled-guard';
import { BeaconSupportAccessGuard } from './beacon-support-access.guard';
import { VehicleProfileV2AccessGuard } from '@app/dashboard/fleet-view/vehicle-profile-v2/guards/index.guard';
import { CoachingAccessGuard } from './coaching-access.guard';
import { DriverProfileV2AccessGuard } from './driver-profile-v2-guard';

const GUARDS = [
  EldGuard,
  VehicleOrAssetGatewayPresentGuard,
  RoleGuard,
  ParamsGuard,
  CompanyFeatureEnabledGuard,
  ApiAccessGuard,
  SupportModeGuard,
  NoSupportModeGuard,
  ModeAccessGuard,
  NoDemoModeGuard,
  GroupAccessGuard,
  FeatureAccessGuard,
  BetaFeatureAccessGuard,
  LogSuggestionUnsavedGuard,
  ConfirmPromptGuard,
  CompanyOperatingModeGuard,
  SubscriptionPlanGuard,
  LoadboardRedirectGuard,
  DevelopmentEnvironmentGuard,
  RedirectGuard,
  ComplianceHubRedirectGuard,
  WebViewAccessGuard,
  TeamDrivingRedirectGuard,
  ComplianceOverviewToCSARedirectGuard,
  LogEditGuard,
  FleetCardsGuard,
  FleetCardsRolesPermissionsGuard,
  FleetCardsFeatureGuard,
  FleetCardsCardApplicationGuard,
  FleetCardsOrderEligibilityGuard,
  CanadianCycleGuard,
  LogRemarkGuard,
  LogEditItemGuard,
  DispatchDriverWorkflowGuard,
  FacilityMonitoringAccessGuard,
  MarketplaceExpansiontAccessGuard,
  PerformanceMarkerGuard,
  FPAMRedirectGuard,
  ShopGuard,
  BillingManagementAccessGuard,
  StatsigFeatureGuard,
  TripsParamsGuard,
  LoadboardSettingsGuard,
  VehicleProfileV2AccessGuard,
  DriverProfileV2AccessGuard,
  SafetyOverviewRedirectGuard,
  DriverQualificationEnabledGuard,
  BeaconSupportAccessGuard,
  CoachingAccessGuard,
];

@NgModule({
  providers: GUARDS,
})
export class GuardsModule { }
